jQuery($ => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Swiping
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.m-product-tabs')[0]) {
        const scrollEl = $('.m-product-tabs__scrollbar-progress');

        const maxWidth = document.getElementById('js-horizontal-scroll').scrollWidth;
        
        var elWidth;
 
        $(window).on('load resize', function () {
            elWidth = $('.m-product-tabs__tab-list').width();
        });

        $('.m-product-tabs__tab-list').scroll(function () {
            progressBar();
        });

        function progressBar() {
            const width      = (maxWidth + 16) - elWidth;
            const percentage = (($('.m-product-tabs__tab-list').scrollLeft()) / width ) * 100;

            scrollEl.width(percentage + '%');
        }
    }
}); 